var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters['account/accountData'].role === 'admin-sekolah')?_c('DashboardAdminSekolah'):_c('DashboardSuperadmin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }